<template>
  <SfDrawerToggle
    :content="content"
    :position="position"
    :hide-if-open="hideIfOpen"
    :options="parsedOptions"
    :collapse-tooltip="collapseTooltip"
    :expand-tooltip="expandTooltip"
    @hidden="hideHost"
    @shown="showHost"
  >
    <slot />
  </SfDrawerToggle>
</template>

<script lang="ts" setup>
import type {
  LeftDrawerContent,
  RightDrawerContent,
} from '@app/shared/types/drawer'

import { computed, useHost } from 'vue'

import SfDrawerToggle from '@app/shared/vue/connected/sf-drawer-toggle.vue'

interface BaseProps {
  hideIfOpen?: boolean
  options?: string
  collapseTooltip?: string
  expandTooltip?: string
}

interface LeftDrawerProps extends BaseProps {
  position: 'left'
  content: LeftDrawerContent
}

interface RightDrawerProps extends BaseProps {
  position: 'right'
  content: RightDrawerContent
}

type Props = LeftDrawerProps | RightDrawerProps

const props = defineProps<Props>()

const host = useHost()

const parsedOptions = computed(() => {
  return props.options ? JSON.parse(props.options) : {}
})

function hideHost() {
  if (host) {
    host.style.display = 'none'
  }
}

function showHost() {
  if (host) {
    host.style.display = ''
  }
}
</script>
<style lang="scss">
@import '@app/shared/vue/connected/sf-drawer-toggle';
</style>
